<template>
  <div>
    <!-- 账号设置 -->
    <div class="user-info6 w-100 style2">
      <a v-for="(item, index) in tabs" :key="index" :class="{ active: index == active }" @click="tabChange(index)">{{
        item }}</a>
    </div>
    <div class="user-info10 w-100" v-show="active == 0">
      <div class="center-block">
        <form action="" class="box-info1 w-100" method="post" v-show="active == 0">
          <div class="box1 w-100">
            <span>手机：</span>
            <input type="text" class="text" name="" id="" value="13566585256" placeholder="请输入手机号"
              v-model="userForm.phone" />
            <!-- <i class="binding" @click="undeveloped">重新绑定</i> -->
          </div>
          <div class="yzm w-100">
            <div class="box1 w-100">
              <span>验证码：</span>
              <input type="text" class="text" name="" id="" value="" placeholder="请输入验证码" />
              <input type="button" class="btn" value="获取验证码" />
            </div>
          </div>
          <div class="box1 w-100">
            <span>账户名：</span>
            <input type="text" class="text" name="" id="" v-model="userForm.userName" placeholder="请输入账户名" />
          </div>
          <!-- <div class="box1 w-100" style="display: block;">
            <span>性别：</span>
            <el-radio-group v-model="userForm.gender">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </div> -->
          <!-- <div class="radio-box">
              <label class="radio-inline"><input type="radio" name="sex" checked id="" value="" />男</label>
              <label class="radio-inline"><input type="radio" name="sex" id="" value="" />女</label>
            </div> -->
          <!-- <input
              type="text"
              class="text"
              name=""
              id="test"
              value=""
              placeholder="请设置你的出生日期"
            /> -->
          <!-- <div class="box1 w-100" style="display: block;">
            <span>出生年月：</span>
            <el-date-picker v-model="userForm.birthday" type="date" placeholder="选择出生日期">
            </el-date-picker>
          </div> -->
          <!-- <button type="button" class="layui-btn" id="test1" @click="undeveloped">
                选择图片
              </button> -->
          <!-- <div class="box-info2 w-100" style="width: 42rem;margin-top: 2rem;">
            <div class="pull-left center-center">
              <el-upload :file-list="fileList" class="avatar-uploader"
                :action="baseUrl + '/upload/nologin/uploadAccessory.htm'" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="userForm.headimgUrl" :src="userForm.headimgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span v-if="!userForm.headimgUrl">选择图片</span>
              </el-upload>
              <div class="layui-upload-list">
                <p class="between-center" id="demoText"></p>
              </div>
              <div class="info">
                支持JPG,PNG，尺寸不小于256*256<br />真实高清头像更受欢迎！
              </div>
            </div>

          </div> -->
          <!-- <div class="pull-right">
              <p>头像预览：</p>
              <span class="headPreview"></span>
              <span class="headPreview"></span>
            </div> -->
          <!-- <input class="btns" value="更新" @click="undeveloped"/> -->
          <div class="box-info3 w-100"><a @click="updateUserInfo">更新</a></div>
        </form>
      </div>
    </div>
    <div class="user-info10 w-100 center-center" v-show="active == 1">
      <div class="center-block">
        <form action="" class="box-info1 w-100" method="post">
          <div class="box1 w-100">
            <span><i>*</i></span>
            <input type="password" class="text" name="" id="test" value="" placeholder="请输入前密码"
              v-model="passwordForm.oldPassword" />
          </div>
          <div class="box1 w-100">
            <span><i>*</i></span>
            <input type="password" class="text" name="" id="test" value="" placeholder="请输入新密码"
              v-model="passwordForm.newPassword" />
          </div>
          <div class="box1 w-100">
            <span><i>*</i></span>
            <input type="password" class="text" name="" id="test" value="" placeholder="确认密码"
              v-model="passwordForm.rePassword" />
          </div>
          <!-- <input class="btns" value="确定"  @click="undeveloped"/> -->
          <div class="box-info3 w-100"><a @click="updatePassword">确定</a></div>
        </form>
      </div>
    </div>
    <div class="user-info10 w-100 center-center" v-show="active == 2">

      <div class="box-info3 w-100"><a @click="undeveloped">确定</a></div>
    </div>
  </div>
</template>

<script>
import {
  message
} from '@/common/common.js'
import { updatePassword, updateUserInfo, uploadAccessory } from '../../common/http';
const baseUrl = process.env.NODE_ENV === "development" ? "dev-api" : process.env.VUE_APP_BASE_URL
export default {
  data () {
    return {
      active: 0,
      tabs: ['个人资料', '修改密码'], //
      userForm: {
        userName: '',
        phone: '',
        // birthday: '',
        // gender: '',
        // headimgUrl: ''
      },
      userId: '',
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      baseUrl: baseUrl,
      fileList: []
    }
  },
  mounted () {
    this.$emit('change_bread', 10);
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const { userName, phone, id } = userInfo;
    this.userForm = { userName, phone }
    // this.fileList = [{
    //   url: headimgUrl
    // }]
    this.userId = id
  },
  methods: {
    // handleAvatarSuccess (res, file) {
    //   this.userForm.headimgUrl = res.data[0].url
    // },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    tabChange (idx) {
      if (idx == this.active) {
        return
      }
      this.active = idx
    },
    undeveloped () {
      message({
        message: '功能暂未开放',
        type: 'warning'
      })
    },
    updateUserInfo () {
      if (this.userForm.phone === '') {
        this.$message.error("请填写手机号")
        return
      }
      if (this.userForm.userName === '') {
        this.$message.error("请填写用户名")
        return
      }
      updateUserInfo({ ...this.userForm, userId: this.userId }).then(res => {
        if (res.result) {
          this.$message.success("更新成功")
          localStorage.setItem("userInfo", JSON.stringify(res.data.user))
          window.onload()
        }
        else {
          this.$message.error(res.msg)
        }
      })
    },
    updatePassword () {
      if (this.passwordForm.oldPassword === '') {
        this.$message.error("请填写旧密码")
        return
      }
      if (this.passwordForm.newPassword === '') {
        this.$message.error("请填写新密码")
        return
      }
      if (this.passwordForm.rePassword === '') {
        this.$message.error("请填写确认密码")
        return
      }

      if (this.passwordForm.newPassword !== this.passwordForm.rePassword) {
        this.$message.error("两次密码输入不一致！")
        return
      }
      updatePassword(this.passwordForm).then(res => {
        if (res.result) {
          this.$message.success("修改成功")
          this.$router.push("/")
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/userCenter/accountSettings.vue